var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2819 17.1552L22.7139 23.5872C23.5443 24.4176 23.5443 25.7664 22.7139 26.5968C21.8835 27.4272 20.5347 27.4272 19.7043 26.5968L13.2771 20.16C12.4467 19.3296 12.4467 17.9808 13.2771 17.1504C13.6947 16.7328 14.2371 16.5264 14.7795 16.5264C15.3219 16.5264 15.8691 16.7376 16.2819 17.1552Z",
    fill: "#CC856C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0133 5.4238L34.4453 11.8558C35.2757 12.6862 35.2757 14.035 34.4453 14.8654C33.6149 15.6958 32.2661 15.6958 31.4357 14.8654L25.0037 8.4334C24.1733 7.603 24.1733 6.2542 25.0037 5.4238C25.4213 5.0062 25.9637 4.7998 26.5061 4.7998C27.0485 4.7998 27.6005 5.0062 28.0133 5.4238Z",
    fill: "#CC856C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2812 17.1553L25.0028 8.43372L31.4337 14.8646L22.7121 23.5861L16.2812 17.1553Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8509 33.9984C40.5453 35.304 38.3997 35.184 37.2525 33.744L26.2461 21L28.8525 18.3936L41.5965 29.4C43.0365 30.552 43.1565 32.6976 41.8509 33.9984Z",
    fill: "#BF7862"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5153 16.7803L30.5185 17.7835C30.7969 18.0619 30.7921 18.5131 30.5185 18.7867L26.6401 22.6651C26.3617 22.9435 25.9105 22.9435 25.6321 22.6651L24.6289 21.6619L29.5153 16.7803Z",
    fill: "#CC856C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1606 33.6433V38.5729H8.41016V33.6433C8.41016 33.0769 8.87096 32.6113 9.44216 32.6113H28.1286C28.695 32.6113 29.1606 33.0769 29.1606 33.6433Z",
    fill: "#626C78"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3286 39.5908V43.2004H5.24219V39.5908C5.24219 39.0292 5.69339 38.5684 6.25979 38.5684H31.311C31.8726 38.5732 32.3286 39.0292 32.3286 39.5908Z",
    fill: "#626C78"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.3287 39.5906V43.2002L22.3207 38.573L20.0119 37.5074L19.3063 37.181L18.4039 36.7634L16.8151 36.029L15.3799 35.3618L14.5159 34.9634L9.4375 32.6162H28.1287C28.6999 32.6162 29.1607 33.0818 29.1607 33.6482V38.5778H31.3111C31.8727 38.573 32.3287 39.029 32.3287 39.5906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.85bd8b8880bf1a0ed89458701f0d53e9.svg";
export { ForwardRef as ReactComponent };